/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApplicationConfigs {
    InMobileApiKey = 20,
    InMobileVirtualNumber = 21,
    InMobileCallbackURL = 22,
    TimedHostedServiceIntervalMinutes = 28,
    EventGridPublisherClientUri = 30,
    EventGridPublisherAccessKey = 31,
    FileStorageConnectionString = 40,
    ServicebusConnectionstring = 41,
    ServicebusQueueName = 42,
    FromEmail = 50,
    SMTPServer = 51,
    SendGridClientSecret = 52,
    AzureSearchServiceName = 60,
    AzureSearchServiceAPIKey = 61,
    AzureSearchServiceAdminAPIKey = 62,
    FlexFoneAccount = 70,
    FlexFonePassword = 71,
    CVRApi = 72,
    AlwaysEncryptedEnabled = 80,
    AlwaysEncryptedLoadCertIdentityMethod = 81,
}
